

import configs from '@/config/config.js';
import colums from '../colums/colums.js';

// 个位数补零
const zeroPadding = (n) => (+n > 9 ? n : "0" + +n);

function splitWord(value){
  if(!value) return;
  let valueObj=[];
  var reg = new RegExp("[,;、.，；]");
  if(reg.test(value)){
    value = value.replace(/[,;、.；]/g,',')
  }
  if(value.indexOf(",")>=0){
    valueObj = value.split(",");
  }else{
    valueObj[0]=value;
  }
  return valueObj
}

function setMetaTitle(title) {
 document.title = title +"-"+configs.baseTitle;
 let mobile = navigator.userAgent.toLowerCase()
 if (/iphone|ipad|ipod/.test(mobile)) {
  let iframe = document.createElement('iframe')
  iframe.style.display = 'none'
  // 替换成站标favicon路径或者任意存在的较小的图片即可
  iframe.setAttribute('src', 'static/img/blank.png')
  let iframeCallback = function () {
   setTimeout(function () {
    iframe.removeEventListener('load', iframeCallback)
    document.body.removeChild(iframe)
   }, 0)
  }
  iframe.addEventListener('load', iframeCallback)
  document.body.appendChild(iframe)
 }
}

function matchProgramPath(info){
  let programPath='';
  colums.jmkcate.forEach(item=>{
    if(item.id == info.type_id){
      programPath = item.path
    }
  })
  return programPath;
}

//根据时间排序
function sortDate(array,key,type){
  let newArr=[]
  if(type=='down'){
    newArr = array.sort(function(a,b){
      var x= a[key];
      var y= b[key];
      return x > y ? -1 : x < y ? 1 : 0;
    })
  }else{
    newArr = array.sort(function(a,b){
      var x= a[key];
      var y= b[key];
      return x > y ? 1 : x < y ? -1 : 0;
    })
  }
  return newArr;
}

// 根据首字母排序
function sortName(array,key,type){
  let newArr=[];
  if(type=="down"){
    newArr = array.sort(function(a,b){
      // return b[key].localeCompare(a[key])
      let x=a[key] ||'';
      let y=b[key] ||''
      return y.localeCompare(x)
      
    })
  }else{
    newArr = array.sort(function(a,b){
      let x=a[key] ||'';
      let y=b[key] ||''
      return x.localeCompare(y)
      // return a[key].localeCompare(b[key])
    })
  }
  return newArr
}

// 关键字高亮
function lightKeyword(oldString,keyword){
  if(!oldString){
    return '';
  }
  if(!keyword){
    return oldString;
  }
  let newString ='';
  if(oldString.length>0 && keyword ){
    // 匹配关键字正则
    let replaceReg = new RegExp(keyword,"g");
    // 高亮替换v-html值
    let replaceString = '<span class="lightword">' + keyword + '</span>';
    newString = oldString.replace(replaceReg, replaceString);
  }
    return newString;

}

//根据数量获取过去 的年份  默认10年
function getLastFewYear(number){
  if(!number){
    number=10;
  }
  var a = new Date().getFullYear();
  var yearObj=[];
  for(var i=0;i<number;i++){
    var year = a-i;
    yearObj.push(year)
  }
  return yearObj;
}

function getBetweenYear(minyear,maxyear){
  maxyear = maxyear?maxyear:new Date().getFullYear();
  let arr=[];
  for(let i=maxyear;i>=minyear;i--){
    arr.push(i)
  }
  return arr;
}

//难证码
function getImgCode(){
  var windowUrl = window.URL || window.webkitURL;//处理浏览器兼容性
  var xhr = new XMLHttpRequest();
  var url = "/IGI/***";//验证码请求地址
  xhr.open("GET", url, true);
  xhr.responseType = "blob";
  xhr.onload = function () {
    if (this.status == 200) {
      var blob = this.response;
      $("#code").attr("src", windowUrl.createObjectURL(blob));
    }
  }
  xhr.send();
}


/**
 * 合并相同属性的值 ，并输入新数组
 * @param {原数组} arr 
 * @param {主要的key属性} key 
 * @param {新创建后重新组合的Key属性} newKey 
 * @param {新创建后重新组合的Key属性} newKeyArr 
 * @returns 
 */
function mergeAttribute(arr,key,newKey,...newKeyArr){
  let temArr=[],newArr=[];
  if(newKeyArr.indexOf(",")>=0){
    newKeyArr = newKeyArr.split(",")
  }
  for(let i=0;i< arr.length;i++){
    if(temArr.indexOf(arr[i][key])===-1){
      newArr.push({
        [key]:arr[i][key],
        [newKey]:[{
          [newKey]: arr[i][newKey],
          // [newKeyArr]:arr[i][newKeyArr],
          ...arr[i]
        }]
      })
      temArr.push(arr[i][key])
    }else{
      for(let j=0;j<newArr.length;j++){
        if(newArr[j][key]==arr[i][key]){
          newArr[j][newKey].push({
            [newKey]: arr[i][newKey],
            // [newKeyArr]:arr[i][newKeyArr],
            ...arr[i]
          })
        }
      }
    }
  }
  // console.log(newArr)
  return newArr;
}

function setCookie(name,value,expiredays){
  var exdate = new Date();
  //expiredays改为设置成天
  // exdate.setDate(exdate.getDate()+expiredays);
  //expiredays改为设置成分钟
  // exdate.toUTCString()  转为世界时间（格林威治时间）
  exdate.setTime(exdate.getTime() + expiredays*60*1000)
  document.cookie = name + '=' + escape(value) + ((expiredays == null) ? "" : ";expires=" + exdate.toString())
}

function getCookie(name){
  if(document.cookie.length>0){
    // console.log("cookie",document.cookie)
    var start = document.cookie.indexOf(name+'=');
    if(start !==-1){
      start = start + name.length+1;
      var end = document.cookie.indexOf(';',start);
      if(end ===-1){
        end = document.cookie.length;
      }
      return unescape(document.cookie.substring(start, end))
    }
  }
  return '';
}

function deleteCookie(name){
  var exdate = new Date();
  exdate.setDate(exdate.getDate() -1);
  document.cookie = name +"=";
}

function setSession(name,value){
  // window.sessionStorage(name,value)
  sessionStorage.setItem(name,value)
}
function getSession(name){
  let value = sessionStorage.getItem(name)
  return value
}
function removeSession(name){
  sessionStorage.removeItem(name)
}

// 计算时间
function secondToMin(s){
  var MM = Math.floor(s / 60);
  var SS = s % 60;
  if (MM < 10)
    MM = "0" + MM;
  if (SS < 10)
    SS = "0" + SS;
  var min = MM + ":" + SS;
  return min.split('.')[0];
}


function changeUrlQuery(query){
  let link = window.location.href;
  let newLink='';
  if(link.indexOf("?")>=0){
    newLink = link.split('?')[0];
  }
  newLink = newLink +'?'+query
  history.pushState(null, null,newLink );
}


function hashNum(access){
  let code = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9,
    'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z',
    'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'
   ];
   let newCode =''
  for(let i=0;i<10;i++){
    let charNum = Math.floor(Math.random() * 52);
    if(i==3){
      newCode +=access
    }else{
      newCode += code[charNum]
    }
  } 
  return newCode
}

function isPhone(str){
  let reg = /^1(?:3\d|4[4-9]|5[0-35-9]|6[67]|7[013-8]|8\d|9\d)\d{8}$/;
  if (reg.test(str)){
    return true
  }else{
    return false
  }
}


function filterHtml(str) {
  if (!str) return;
  var reg = RegExp(/<.*?>/g)
  var newStr = str.replace(reg, "")
  var reg2 = RegExp(/&nbsp;|&ensp;|&emsp;|&thinsp;|&zwnj;|&zwj;/g)
  newStr = newStr.replace(reg2,"")
  // newStr = newStr.replaceAll('&nbsp;',"")
  // newStr = newStr.replaceAll('&ensp;',"")
  // newStr = newStr.replaceAll('&emsp;',"")
  // newStr = newStr.replaceAll('&thinsp;',"")
  // newStr = newStr.replaceAll('&zwnj;',"")
  // newStr = newStr.replaceAll('&zwj;',"")
  return newStr
}


function fileType(file){
  if (!file ) return false;
  let typeobj = file.split("/")
  if (!typeobj) return
  return typeobj[0]
}

function fileInclude(fileobj){
  // image/*,application/zip,.zip,application/rar,.rar,application/7z,application/vnd.ms-excel,application/vnd.ms-powerpoint,application/pdf,application/msword,text/plain,text/csv,audio/mpeg,audio/3gpp,video/3gpp,audio/mp4,video/mp4,application/ogg,audio/ogg,.docx,.pptx,.xlsx
  let allFile =['.txt',".doc",".docx",".zip",".rar",".7z",".xls",".xlsx",".ppt",".pptx","doc",".docx",".csv",".pdf"]
  
  if (!fileobj) return false
  if(!fileobj.name  && !fileobj.type) return false 
  let type1 = fileobj.type.split("/")
  if (!type1) return false

  // 判断是否为image类型、audio类型或video类型
  if(type1[0]=='image' || type1[0]=='video' || type1[0]=='audio'){
    return true
  }  
  //判断文件类型
  try{
    let filename = fileobj.name.split(".")
    if(!filename) return false
    let name = filename[filename.length - 1]
    if(allFile.indexOf("."+name) >=0){
      return true
    }else{
      return false
    }
  }catch(err){
    return false
  }
}


function hasSpecialChar(str) {
  return /[^a-zA-Z0-9]/.test(str);
}

const shareToWeibo = function (obj) {
  const weiboTag = `#${baseTitle}#`
  const title = obj.title + weiboTag
  const pic = obj.pic

  const path = "https://service.weibo.com/share/share.php"
  const params = {
    url: obj.sharePath,
    type: "3",
    count: "1",
    appkey: "2841902482",
    title,
    pic,
    ralateUid: "",
    share_source: "weibo",
    language: "zh_cn",
    rnd: (new Date).valueOf()
  }
  
  let pList = [];
  for (let k in params) {
    if (params[k] || params[k] === 0) {
      pList.push(`${k}=${encodeURIComponent(params[k])}`);
    }
  }
  const blogUrl = `${path}?${pList.join('&')}`

  const newWindow = window.open(blogUrl, title, 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=yes, copyhistory=no,  width=700, height=600');
  newWindow.onload = function () {
    // 定时器根据实际情况取舍。
    setTimeout(function () {
      newWindow.document.title = title;
    }, 100)
  }
};

const onShareQQZone = function (obj) {
  // 分享的标题
  var title = encodeURIComponent(obj.title || document.title);
  // 分享内容链接
  var url = encodeURIComponent(obj.sharePath || window.location.href);
  // 分享图片的路径，多张图片以＂|＂隔开，可选参数
  var picurl = encodeURIComponent(obj.pic || '');
  // 分享描述
  var content = encodeURIComponent(obj.content || '');
  var blogUrl =
    'http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?summary=' + title
    + '&desc=' + content
    + '&url=' + url
    + '&pics=' + picurl;

  const newWindow = window.open(blogUrl, title, 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=yes, copyhistory=no,  width=700, height=600');
  newWindow.onload = function () {
    // 定时器根据实际情况取舍。
    setTimeout(function () {
      newWindow.document.title = title;
    }, 100)
  }
};

const formatDates = (val) => {
  let str = ''
  if (val) {
    val = val.replace(/-/g, '/').replace(/T/g, ' ')
    var date1=new Date(val);
    var year = date1.getFullYear();
    var mon = date1.getMonth() + 1
    var dates = date1.getDate()
    str = year + '-' + zeroPadding(mon) + '-' + zeroPadding(dates)
  }
  return str
}

const openWindow = (url) => {
  if (url) {
    const tempwindow = window.open('_blank');
    tempwindow.location = url;
  }
}

function formatChartData(tagName,lineName='',source='',category='',obj){
  tagName = tagName && typeof tagName =='number'? tagName.toString():tagName
  return{
    // abstracts:tagName,
    tagName:tagName,
    fTagClassName:lineName,
    source:source,
    category:category,
    data:obj?obj:null
  }
}


function resetHtml(str){
  if (!str) return str
  let reg = new RegExp(/\r\n/gi)
  str = str.replace(reg,"<br/>")
  let reg1 = new RegExp(/\n/gi)
  str = str.replace(reg1,"<br/>")
  let reg2 = new RegExp(/\r/gi)
  str = str.replace(reg2,"<br/>")
  return str
}

const newsQuery = (oldQuery,subject)=>{
  if(!subject) return oldQuery
  if(subject){
    return {
      ...oldQuery,
      subject
    }
  }
}

const fixedHtmlAuthor = (list)=>{
  let arr = []
  if (list && list.length) {
    const arr1 = list.filter(v => v.artist_typename == '作者')
    const arr2 = list.filter(v => v.artist_typename != '作者')

    const arr3 = arr2.map(v => v.isrc == 1 ? `<a class="cl-red" href="/#/artist/${v.artist_id}">${v.artist_name}</a>(${v.artist_typename})` : `${v.artist_name}(${v.artist_typename})`)
    const arr4 = arr1.map(v => v.isrc == 1 ? `<a class="cl-red" href="/#/artist/${v.artist_id}">${v.artist_name}</a>` : v.artist_name)
    arr = arr.concat(arr3, arr4 && arr4.length ? arr4.join(',') + '(著)' : [])
  }
  return arr.join('、')
}

const fixedAuthor = (list)=>{
  let arr = []
  if (list && list.length) {
    const arr1 = list.filter(v => v.artist_typename == '作者')
    const arr2 = list.filter(v => v.artist_typename != '作者')
    
    const arr3 = arr2.map(v => `${v.artist_name}(${v.artist_typename})`)
    const arr4 = arr1.map(v => v.artist_name)
    arr = arr.concat(arr3, arr4 && arr4.length ? arr4.join(',') + '(著)' : [])
  }
  return arr.join('、')
}

function generateRandomCode(length) {
  let result = '';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
 
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
 
  return result;
}

const randomList = (list) => {
  list.sort(function() {
    return .5 - Math.random();
  });
  return list
}

const formatAuthorIntro = (row, hideName = false) => {
  const infoList = []
  const authorText = filterHtml(row.introduce)
  if (authorText) {
    // const cityList = []
    // row.province && cityList.push(row.province.replace('省', ''))
    // row.city && cityList.push(row.city.replace('市', ''))
    // cityList && cityList.length && cityList.push('人')
    // !hideName && row.name && infoList.push(row.name)
    // row.sex && infoList.push(row.sex)
    // cityList && cityList.length && infoList.push(cityList.join(''))
    authorText && infoList.push(row.introduce)
  }
  return infoList.join('，')
}

export default{
  splitWord,
  setMetaTitle,
  matchProgramPath,
  sortDate,
  sortName,
  lightKeyword,
  getLastFewYear,
  getBetweenYear,
  getImgCode,
  mergeAttribute,
  setCookie,
  getCookie,
  deleteCookie,
  secondToMin,
  changeUrlQuery,
  hashNum,
  isPhone,
  filterHtml,
  fileType,
  fileInclude,
  hasSpecialChar,
  setSession,
  getSession,
  removeSession,
  shareToWeibo,
  formatDates,
  zeroPadding,
  openWindow,
  formatChartData,
  resetHtml,
  newsQuery,
  onShareQQZone,
  fixedAuthor,
  fixedHtmlAuthor,
  generateRandomCode,
  randomList,
  formatAuthorIntro
}